module.exports = __webpack_public_path__ + "img/done.56802fd9.svg";